import Link from 'next/link'
import React, { useState, useRef } from 'react'

import NavigationComponent from './shared/NavigationComponent'
import UserComponent from './shared/UserComponent'
import Image from 'next/image'

// import useCategoryInformation, {CategoryInformationInterface} from '../lib/useCategoryHelper'

export default function Header() {
  // const [categoryInformation] = useCategoryInformation();

  const [navigationCollapsed, setNavigationCollapsed] = useState(true);
  const [userCollapsed, setUserCollapsed] = useState(true);
  const navToggleRef = useRef<HTMLButtonElement>(null);

  const toggleNavigation = () => {
    setNavigationCollapsed(!navigationCollapsed)
    if (!navigationCollapsed) document.body.classList.remove('overflow-hidden')
    else document.body.classList.add('overflow-hidden')
  }

  const toggleUser = () => {
    setUserCollapsed(!userCollapsed)
    if (!userCollapsed) document.body.classList.remove('overflow-hidden')
    else document.body.classList.add('overflow-hidden')
  }

  const showCmp = () => {
    toggleNavigation()
    if (window && (window as any).__cmp) {
      (window as any).__cmp('showScreen')
    }
  }

  return (
    <header id="header">
      <div className="header-top">
        <button 
          ref={navToggleRef}
          id="nav-toggle" 
          aria-label="Menü" 
          className={!navigationCollapsed ? 'open' : ''} 
          onClick={toggleNavigation}
        >
          <div className="nav-toggle-icon">
            <div />
            <div />
            <div />
          </div>
        </button>
        <div className="header-logo">
          <Link href="/" className="header-logo-container">
            {/* <a className="header-logo-container"> */}
              <Image
                src={`/logos/logo-nuernberger-nachrichten.png`}
                priority alt="Logo"
                fill
                className="object-contain text-center dark:filter brightness-0 invert"
              />
            {/* </a> */}
          </Link>
        </div>
        <div className="header-right">
          <button className="header-user" aria-label="Login" onClick={toggleUser}>
            <span className="icon-kandidat" />
          </button>
        </div>
      </div>
      <NavigationComponent 
        isCollapsed={navigationCollapsed} 
        showCmp={showCmp} 
        toggleOverlay={toggleNavigation}
        triggerRef={navToggleRef as React.RefObject<HTMLButtonElement>}
      />
      <UserComponent isCollapsed={userCollapsed} toggleOverlay={toggleUser} />
    </header>
  );
}